/*eslint no-process-env:0*/

// Production specific configuration
// =================================
module.exports = {
    // Server IP
    ip: process.env.OPENSHIFT_NODEJS_IP
        || process.env.ip
        || undefined,

    // Server port
    port: process.env.OPENSHIFT_NODEJS_PORT
        || process.env.PORT
        || 8094,
    url: "http://192.0.0.53:8094",

        sequelize: {
            host: '127.0.0.1',
            username: 'root',
            password: 'carminoDL207',
            database: 'lightbox',
            dialect: 'mysql',
            port: '3030'
    },
};
